import React from 'react'

import { Link as GatsbyLink } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import PropTypes from 'prop-types'

const Link = ({
  children,
  to,
  className,
  activeClassName,
  partiallyActive,
  ...props
}) => {
  const internal = /^\/(?!\/)/.test(to)

  if (internal) {
    const isAnchorLink = /^#/.test(to)

    const Link = !isAnchorLink ? GatsbyLink : AnchorLink

    return (
      <Link
        to={to}
        className={className}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...props}
      >
        {children}
      </Link>
    )
  }

  return (
    <a href={to} className={className} {...props}>
      {children}
    </a>
  )
}

Link.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  partiallyActive: PropTypes.bool,
  other: PropTypes.object
}

export default Link
